import { Injectable } from '@angular/core';
var TabsetConfig = (function () {
    function TabsetConfig() {
        /** provides default navigation context class: 'tabs' or 'pills' */
        this.type = 'tabs';
    }
    return TabsetConfig;
}());
export { TabsetConfig };
TabsetConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
TabsetConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=tabset.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tabs/tabset.config.js
// module id = 114
// module chunks = 3